import React from 'react';
import { Grid, Table, Segment, Button, Image, Checkbox, Modal, Input } from 'semantic-ui-react';
import DateTimePicker from 'react-datetime';
import { S3_BASE_URL } from '../../config/API';

const ListVMByVariantId = ({
  loading,
  list,
  product,
  onSelect,
  slectedVMs,
  onExpireAll,
  onExpireSelected,
  totalCountOfProduct,
  openModal,
  closeModal,
  onScheduleExpiry,
  expiryDateTime,
  onChangeOfExpiryDate,
  onClickOfScheduleInModal
}) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <React.Fragment>
      <Modal
        size="mini"
        open={openModal}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onClose={closeModal}
        closeIcon
        centered={false}
      >
        <Modal.Header>Schedule Expiry</Modal.Header>
        <Modal.Content>
          <p>Provide expiry time for the product in selected VMs</p>
          <br />
          <Input>
            <DateTimePicker value={expiryDateTime} onChange={onChangeOfExpiryDate} />
          </Input>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="blue" onClick={onClickOfScheduleInModal} disabled={loading}>
            Schedule
          </Button>
        </Modal.Actions>
      </Modal>
      <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
        <Grid.Row centered>
          <Grid.Column width={4}>
            <h2
              style={{
                fontWeight: 400,
                border: '1px solid #555',
                textAlign: 'center',
                color: '#555',
                padding: '0.5em'
              }}
            >
              VM Listing for Product
            </h2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered>
          <Grid.Column width={6}>
            {product ? (
              <Table definition>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Product Id / Name </Table.Cell>
                    <Table.Cell>
                      {product.id} / {product.variant_name}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Vendor / Meal Type / Offer Price</Table.Cell>
                    <Table.Cell>
                      {product.manufacturer_name} / {product.meal_type} / Rs. {product.offer_price}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Image</Table.Cell>
                    <Table.Cell>
                      {product.image_id && (
                        <Image
                          style={{ height: '80px', width: '150px' }}
                          src={`${S3_BASE_URL}/${product.image_id}`}
                        />
                      )}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Total Count </Table.Cell>
                    <Table.Cell>
                      {totalCountOfProduct}{' '}
                      <span style={{ color: '#ff7675' }}>&nbsp;(*Including duplicate slots)</span>{' '}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            ) : null}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered>
          <Grid.Column width={8}>
            <h4
              style={{
                fontWeight: 400,
                textAlign: 'center',
                color: '#ff7675',
                padding: '0.5em'
              }}
            >
              * Not showing duplicate slots, choose Vending Machine to expire the product
            </h4>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="left" width={3}>
            <Button basic color="blue" onClick={onExpireAll} disabled={loading}>
              Expire All
            </Button>
          </Grid.Column>
          <Grid.Column textAlign="center" width={3}>
            <Button basic color="blue" onClick={onScheduleExpiry}>
              Schedule Selected ({slectedVMs})
            </Button>
          </Grid.Column>
          <Grid.Column textAlign="right" width={4}>
            <Button basic color="blue" onClick={onExpireSelected} disabled={loading}>
              Expire Selected ({slectedVMs})
            </Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered>
          <Grid.Column width={10}>
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Select</Table.HeaderCell>
                  {/* <Table.HeaderCell>Product Id</Table.HeaderCell> */}
                  <Table.HeaderCell>VM Id</Table.HeaderCell>
                  <Table.HeaderCell>VM Slot</Table.HeaderCell>
                  <Table.HeaderCell>Active + Hold</Table.HeaderCell>
                  <Table.HeaderCell>VM Address</Table.HeaderCell>
                  <Table.HeaderCell>VM Image</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {list &&
                  list.length &&
                  list.map(el => (
                    <Table.Row>
                      <Table.Cell>
                        {' '}
                        <Checkbox onChange={() => onSelect(el.vending_machine_id)} />
                      </Table.Cell>
                      {/* <Table.Cell>{el.manufacturer_variant_id}</Table.Cell> */}
                      <Table.Cell>{el.vending_machine_id}</Table.Cell>
                      <Table.Cell>{el.slot_identifier}</Table.Cell>
                      <Table.Cell style={{ textAlign: 'center' }}>
                        {el.active_count} + {el.hold_count}
                      </Table.Cell>
                      <Table.Cell>{el.street}</Table.Cell>
                      <Table.Cell>
                        {el.image_id && (
                          <Image
                            style={{ height: '80px', width: '150px' }}
                            src={`${S3_BASE_URL}/${el.image_id}`}
                          />
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

export default ListVMByVariantId;



// WEBPACK FOOTER //
// ./src/Modules/ListVMForVariantID/component.jsx